module.exports = __webpack_public_path__ + "static/fonts/Inter.3220473.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter.ttf
// module id = 1017
// module chunks = 11